export default __webpack_public_path__ + "static/media/main.863891e2.png";